import { ReadonlyURLSearchParams } from 'next/navigation';

export const EMPTY_SEARCH_PARAMS = new ReadonlyURLSearchParams(
  new URLSearchParams(),
);
